document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".js-tooltip-item");
  const valueProps = document.querySelectorAll(".trust-seals__item");
  const reviewHeight = Array.from(document.querySelectorAll(".product__selected-review"))?.map(i=>i.offsetHeight).filter(Boolean)[0] || 0;
  const descriptionHeight = document.querySelector(".product__short-description")?.offsetHeight || 0;
  const supportsHeight = document.querySelector(".product-supports-feature")?.offsetHeight || 0;
  const vpHeight = document.querySelector(".trust-seals")?.offsetHeight || 0;
  const bottomVp = reviewHeight + descriptionHeight + supportsHeight + vpHeight +45;

  items.forEach((item, index ) => {
    const tooltipText = item.getAttribute("data-tooltip");
    const tooltipAutoship = document.createElement("div");
    tooltipAutoship.className = "tooltip-autoship";
    tooltipAutoship.innerText = tooltipText;
    item.appendChild(tooltipAutoship);
    if (index%4 === 0 && window.innerWidth > 768) {
      tooltipAutoship.style.width = "55%";
    }
    if (window.innerWidth > 768 && window.innerWidth < 1160){
      if(index%4 === 1 || index%4 === 3){
        tooltipAutoship.style.right = "15%";
      }
    }
    item.addEventListener("click", function () {
      items.forEach((i) => i.classList.remove("active"));
      if (!item.classList.contains("active")) {
        item.classList.add("active");
      }
    });
  });
  valueProps.forEach((valueProp,index ) => {
    const tooltipText = valueProp.getAttribute("data-tooltip");
    const tooltipValueProp = document.createElement("div");
    tooltipValueProp.className = "tooltip-valueProp";
    tooltipValueProp.innerText = tooltipText;
    valueProp.appendChild(tooltipValueProp);
    let left;
    let rect = valueProp.getBoundingClientRect();
    if(window.innerWidth > 768){
      if(index===0 || (window.innerWidth > 768 && window.innerWidth < 1160)){
        left = 0;
        tooltipValueProp.style.width = "100%";
      }else{
        left = index*(rect.width-10) ;
      }
      tooltipValueProp.style.left = `${left}px`;
      tooltipValueProp.style.bottom = `${bottomVp}px`;
    }else{tooltipValueProp.style.bottom = `${bottomVp+50}px`;}
    if (window.innerWidth >= 1160) {
      const widths = [63, 41, 45, 63, 58, 52];
      tooltipValueProp.style.width = `${widths[index % 6]}%`;
    }
    valueProp.addEventListener("click", function () {
      valueProps.forEach((i) => i.classList.remove("active"));

      if (!valueProp.classList.contains("active")) {
        valueProp.classList.add("active");
      }
    });
  });

  document.addEventListener("click", function (event) {
    if (!event.target.closest(".item")) {
      items.forEach((item) => item.classList.remove("active"));
    }
    if (!event.target.closest(".trust-seals__item")) {
      valueProps.forEach((valueProp) => valueProp.classList.remove("active"));
    }
  });
});
